import {
    Dialog,
} from "@mui/material";
import React from 'react'
import CloseModalBtn from '../../assets/nexus/btn-close.png';
import HourGlass from '../../assets/nexus/hourglass.png';
import ModalFooter from '../../assets/nexus/modalfooter.png';

const NexusSalesModal = (props) => {
    const { handleClose, open } = props;

    return (
        <Dialog
            fullWidth
            maxWidth={"sm"}
            open={open}
            onClose={() => {
                handleClose();
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className={"nexus-modal-container"}
        >
            <div onClick={handleClose} className={"nexus-sales-close-btn"}>
                <img src={CloseModalBtn} title={"Close"} alt={"Close"}/>
            </div>
            <div className={"nexus-sales-hourglass"}>
                <img src={HourGlass} alt={"Hourglass"} title={"Hourglass"}/>
            </div>
            <div className={"nexus-sales-modal"}>
                <div className={"nexus-sales-modal__header"}>
                    <label>Retirement Roadmap will sunset on </label>
                    <h1>January 5 2026</h1>
                </div>
                <div className={"nexus-sales-modal__body"}>
                    <p>
                        But don't worry! Nexus, a brand new and enhanced version, is live right now!
                    </p>
                    <p>
                        As a thank you to Retirement Roadmap customers, we are offering you your first year on Nexus <span style={{color: "green"}}>for only $899.</span>
                    </p>
                    <p>
                        To learn more, visit the website: <br />
                        <a href={"http://roadmaptonexus.com/?utm_source=roadmap_app&utm_medium=splash&utm_campaign=roadmap2nexus&utm_content=sunset_dec_2025_save420"} target={"_blank"}>www.roadmaptonexus.com</a>
                    </p>

                </div>
                <hr/>
                <div className={"nexus-sales-modal__footer"}>
                    <img src={ModalFooter} alt={"Wealth Central Nexus"} title={"Wealth Central Nexus"}/>
                </div>
            </div>
        </Dialog>)
}

export default NexusSalesModal;